module.exports = __webpack_public_path__ + "img/suche_nav.3655e59f.svg";